import { useEffect, useState } from 'react';
import FormGroup from './FormGroup';

const Input = ({
    value,
    name,
    label,
    requirementText,
    isRequired,
    showError,
    externalErrorMessage,
    onChange = () => {},
    type = 'text',
    placeholder,
    inlineStyle = {},
}) => {
    const [inputValue, setInputValue] = useState(value);
    const [isValid, setIsValid] = useState(true);

    const checkValidity = value => {
        let valid = true;
        if (isRequired) {
            valid = value.length > 0;
        }
        return valid;
    };

    useEffect(() => {
        // Update the input value and validity when the value prop changes
        setIsValid(checkValidity(value));
        setInputValue(value);
    }, [value]);

    const handleInputChange = e => {
        e.preventDefault();
        if (type === 'number') {
            const value = e.target.value.replace(/[^0-9]/g, '');
            e.target.value = value;
        }
        const valid = checkValidity(e.target.value);
        setIsValid(valid);
        setInputValue(e.target.value);
        onChange(e, valid);
    };
    const errorText = showError && !isValid ? requirementText : '';
    const hasError = showError && (!isValid || externalErrorMessage);
    return (
        <FormGroup
            label={label}
            requirementText={requirementText}
            name={name}
            showError={showError}
            externalErrorMessage={errorText}
            required={isRequired}
        >
            <input
                role={type === 'number' ? 'spinbutton' : 'textbox'}
                value={inputValue}
                type="text"
                id={name}
                name={name}
                className={`form-control ${hasError ? ' error' : ''}`}
                placeholder={placeholder}
                style={inlineStyle}
                onChange={handleInputChange}
            />
        </FormGroup>
    );
};

export default Input;
